import sdkInstanceProvider from "../../providers/sdkInstanceProvider";
import clientConfigurationProvider from "../../providers/clientConfigurationProvider";
import { ServiceError, SdkError } from "../errors";
import isServiceError from "./isServiceError";

export default async itemId => {
  const sdkInstance = await sdkInstanceProvider("savedItems");
  const { removeItemRequestTimeout } = clientConfigurationProvider();

  try {
    const { data } = await sdkInstance.removeItem({
      itemId,
      requestOptions: {
        timeout: removeItemRequestTimeout
      }
    });

    return data;
  } catch (e) {
    if (isServiceError(e)) {
      throw new ServiceError(e);
    }
    throw new SdkError(e);
  }
};
